import {
  ADMIN_LOGIN_ERROR,
  ADMIN_LOGIN_SUCCESS,
  ADMIN_LOGIN_REQUEST,
  ADMIN_LOGOUT,
  ADMIN_BILLING_REQUEST,
  ADMIN_BILLING_SUCCESS,
  ADMIN_BILLING_ERROR,
  ADMIN_OWNER_INFO_UPDATE_REQUEST,
  ADMIN_OWNER_INFO_UPDATE_SUCCESS,
  ADMIN_OWNER_INFO_UPDATE_ERROR,
  ADMIN_OWNER_INFO_UPDATE_INCOMPLETE,
  ADMIN_OWNER_INFO_RESET,
} from "./constants"
import { AdminStore, OwnerInfoDraft, OwnerInfoField, OwnerInfoState } from "types/store"
import { Admin } from "types/entity"
import { Action, Message } from "types/redux"

const initialOwnerInfo: OwnerInfoState = {
  loading: false,
  status: "idle",
}

const initialState: Partial<AdminStore> = {
  success: false,
  loading: false,
  ownerInfo: initialOwnerInfo,
}

const reducer = function adminReducer(
  state = initialState,
  action: Action<
    Admin | Message | OwnerInfoDraft | { missing: OwnerInfoField; draft: OwnerInfoDraft }
  >
): Partial<AdminStore> {
  switch (action.type) {
    case ADMIN_LOGOUT:
      return { ...state, loading: false, success: false }
    case ADMIN_LOGIN_REQUEST:
      return { ...state, loading: true, message: undefined }
    case ADMIN_LOGIN_SUCCESS:
      return {
        ...state,
        message: { text: "Vous êtes bien connecté", type: "success" },
        success: true,
        loading: false,
      }
    case ADMIN_LOGIN_ERROR:
      return {
        ...state,
        message: action.payload as Message,
        success: false,
        loading: false,
      }
    case ADMIN_BILLING_REQUEST:
      return { ...state, loading: true, message: undefined, success: false }
    case ADMIN_BILLING_SUCCESS:
      return { ...state, message: { text: "Ajout données de facturation réussie", type: "success" }, success: true, loading: false }
    case ADMIN_BILLING_ERROR:
      return { ...state, message: action.payload as Message, success: false, loading: false }
    case ADMIN_OWNER_INFO_RESET:
      return { ...state, ownerInfo: initialOwnerInfo }
    case ADMIN_OWNER_INFO_UPDATE_REQUEST:
      return {
        ...state,
        ownerInfo: { ...initialOwnerInfo, loading: true, draft: state.ownerInfo?.draft },
      }
    case ADMIN_OWNER_INFO_UPDATE_SUCCESS:
      return {
        ...state,
        ownerInfo: { loading: false, status: "success", message: action.payload as Message },
      }
    case ADMIN_OWNER_INFO_UPDATE_ERROR:
      return {
        ...state,
        ownerInfo: {
          ...(state.ownerInfo ?? initialOwnerInfo),
          loading: false,
          status: "error",
          message: action.payload as Message,
        },
      }
    case ADMIN_OWNER_INFO_UPDATE_INCOMPLETE: {
      const { missing, draft } = action.payload as { missing: OwnerInfoField; draft: OwnerInfoDraft }
      return {
        ...state,
        ownerInfo: { loading: false, status: "incomplete", missing, draft },
      }
    }
    default:
      return { ...state, message: undefined }
  }
}

export default reducer
